import React, { useState, useRef, useEffect } from "react";
import Background from "./../assets/resources/queens3.jpg";
import LinkCart from "../Components/Home/LinkCart";
import "./building_page.css";
import imgCardDatas from "./imgcard.json";
// import Map from '../Components/Map/MapBox'
import Map1 from "../Components/Map/MapBox1";
// import MapTest from '../Components/Map/test'
import { Helmet } from "react-helmet";

export default function Neighborhood() {
  const [isScrolledToSection, setIsScrolledToSection] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
  });

  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);
  const section5Ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting) {
            switch (id) {
              case "section1":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: false,
                  section3: false,
                  section4: false,
                });
                break;
              case "section2":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: false,
                  section4: false,
                });
                break;
              case "section3":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: false,
                });
                break;
              case "section4":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              case "section5":
                setIsScrolledToSection({
                  section5: true,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              default:
                return;
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    const sections = [
      section1Ref,
      section2Ref,
      section3Ref,
      section4Ref,
      section5Ref,
    ];
    sections.forEach((sectionRef) => {
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
    });

    return () => {
      sections.forEach((sectionRef) => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      });
    };
  }, [isScrolledToSection]);
  return (
    <>
      <Helmet>
        <title>
          Modern Office Space in Downtown Flushing, NY | Union Center
        </title>
        <meta
          name="description"
          content="Located in the heart of Downtown Flushing, Union Center offers unparalleled access to public transportation, dining, shopping, and Queens' most vibrant business district."
        />
        <meta
          name="keywords"
          content="Union Center location, Downtown Flushing office, Queens business district, Flushing commercial area, NYC office location"
        />
        <link rel="canonical" href="https://www.3716union.com/neighborhood" />
        <meta
          property="og:title"
          content="Prime Downtown Flushing Location | Union Center"
        />
        <meta
          property="og:description"
          content="Discover Union Center's prime location in Downtown Flushing, with easy access to transportation, dining, and Queens' business hub."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.3716union.com/neighborhood"
        />
        {/* Add structured data for location */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "RealEstateAgent",
              "name": "Union Center",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "37-16 Union Street",
                "addressLocality": "Flushing",
                "addressRegion": "NY",
                "postalCode": "11354",
                "addressCountry": "US"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": "40.7614",
                "longitude": "-73.8291"
              }
            }
          `}
        </script>
      </Helmet>
      <div className="flex w-full flex-col bg-white">
        <div className="relative">
          <img
            className="w-full h-screen object-cover"
            src={Background}
            alt="Background"
          />
          <div className="absolute inset-0 bg-[#7e6140] opacity-0"></div>
        </div>
        <div className="w-full text-[#00000] text-base bg-white">
          <section className="py-16">
            <div className="w-full flex bg-white -mt-4 md:-mt-0">
              <div className="w-full max-w-[880px] mx-auto md:text-center px-4">
                <p className="text-brown ">NEIGHBORHOOD</p>
                <p className="text-[#7e6140] text-4xl md:text-5xl font-normal leading-normal md:leading-snug pb-1 md:pb-3">
                  Centrally Located,
                  <br />
                  Well Connected
                </p>
                <p>
                  Union Center will have direct access to a broad NYC Metro area
                  market of 10M+ residents. With close proximity to an extensive
                  transportation network, Union Center provides easy access to
                  Queens, Brooklyn, Manhattan, and Long Island. The building is
                  located one block from the Main Street - Flushing Station,
                  providing direct access to/from Long Island City, Grand
                  Central, Times Square and Hudson Yards via the 7 train.
                </p>
              </div>
            </div>
          </section>

          <section className="w-full pb-40 md:pb-0">
            {/* <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2401433059!2d-73.83149492346786!3d40.76265623388319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2600e0b5c2f7f%3A0x21fe5e4c561a9e0b!2s3716%20Union%20St%2C%20Flushing%2C%20NY%2011354!5e0!3m2!1sen!2sus!4v1698075330409!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe> */}
            <Map1 />
          </section>
        </div>
        <div className="w-full py-24 text-[#00000] bg-[rgb(240,237,232)]">
          <section className="max-w-[1290px] text-base ml-auto mr-auto px-10 ">
            <div
              className={`max-w-[980px] text-lg ml-auto text-right relative ${
                isScrolledToSection.section2
                  ? "top-0 opacity-100"
                  : "top-24 opacity-0"
              } transition-all duration-700`}
            >
              <p className="max-w-[980px] text-brown text-base">EXPLORE</p>
              <h2 className="max-w-[980px] text-[#7e6140] text-5xl mt-3 font-normal pb-3">
                Enjoy Easy Access to Multiple
                <br />
                Transportation Options
              </h2>
              <div ref={section2Ref} id="section2"></div>
            </div>
          </section>
          <section className="w-full block mt-[96px]">
            <div className="w-full md:flex items-start justify-between gap-10 relative">
              <div
                ref={section3Ref}
                id="section3"
                className="absolute top-[60px]"
              ></div>
              <div className="gap-8 md:gap-12 justify-between mx-auto grid grid-cols-2 md:grid-cols-4">
                {imgCardDatas.data.map((imgCardData, index) => (
                  <LinkCart
                    key={index}
                    className={`${
                      isScrolledToSection.section3
                        ? "top-0 opacity-100"
                        : `top-[${(index + 1) * 60}px] opacity-0`
                    } transition-all duration-[${
                      500 + index * 250
                    }ms] relative`}
                    img={imgCardData.cardSrc || imgCardData.src}
                    name={imgCardData.name}
                    link={`/neighborhood/${imgCardData.slug}`}
                    textColor="!text-gray-dark"
                  />
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
